const API_PORT = import.meta.env.VITE_API_PORT || 8107;
const isDevelopment = import.meta.env.DEV;

// In development, use localhost with port
// In production, use relative path
const API_BASE = isDevelopment 
  ? `http://localhost:${API_PORT}/api`
  : `/api`;

export const API_ENDPOINTS = {
  serverStatus: `${API_BASE}/server-status`,
  leaderboards: {
    survival: `${API_BASE}/leaderboards/survival`,
    tycoon: `${API_BASE}/leaderboards/tycoon`,
    global: `${API_BASE}/leaderboards/global`,
    voters: `${API_BASE}/leaderboards/voters`
  },
  store: {
    products: `${API_BASE}/store/products`,
    product: (id: string) => `${API_BASE}/store/products/${id}`,
    createTransaction: `${API_BASE}/store/transactions`,
    paymentDetails: (reference: string) => `${API_BASE}/store/transactions/${reference}`
  },
  admin: {
    login: `${API_BASE}/admin/login`,
    transactions: `${API_BASE}/admin/transactions`,
    sendActions: `${API_BASE}/admin/send-actions`,
    resendAction: (id: string) => `${API_BASE}/admin/send-actions/${id}/resend`,
    products: `${API_BASE}/admin/products`,
    product: (id: string) => `${API_BASE}/admin/products/${id}`,
    gamemodeImages: `${API_BASE}/admin/gamemode-images`,
    gamemodeImage: (id: string) => `${API_BASE}/admin/gamemode-images/${id}`,
    toggleGamemodeImage: (id: string) => `${API_BASE}/admin/gamemode-images/${id}/toggle`
  },
  gamemodes: {
    images: `${API_BASE}/gamemodes/images`
  }
}; 